(function () {
  'use strict';

  // --- Countdown timer (evergreen: resets per-session once expired) ---
  function initCountdowns() {
    document.querySelectorAll('.cro-countdown[data-duration-hours]').forEach(function (el) {
      var digits = el.querySelector('.cro-countdown__digits');
      if (!digits) return;

      var storageKey = 'cro-countdown-' + el.dataset.key;
      var durationMs = parseFloat(el.dataset.durationHours) * 60 * 60 * 1000;
      var deadline = parseInt(sessionStorage.getItem(storageKey), 10);

      if (!deadline || deadline < Date.now()) {
        deadline = Date.now() + durationMs;
        try {
          sessionStorage.setItem(storageKey, String(deadline));
        } catch (e) {
          /* storage unavailable, timer just won't persist across reloads */
        }
      }

      function tick() {
        var remaining = deadline - Date.now();
        if (remaining <= 0) {
          deadline = Date.now() + durationMs;
          try {
            sessionStorage.setItem(storageKey, String(deadline));
          } catch (e) {}
          remaining = durationMs;
        }
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);
        digits.textContent =
          String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  // --- Pack pricing pills: set quantity + reflect selected price ---
  function initPackPricing() {
    document.querySelectorAll('.cro-packs').forEach(function (wrapper) {
      var quantityInput = document.getElementById(wrapper.dataset.quantityInputId);
      var options = wrapper.querySelectorAll('.cro-pack-option');

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          options.forEach(function (o) {
            o.setAttribute('aria-pressed', 'false');
          });
          option.setAttribute('aria-pressed', 'true');

          if (quantityInput) {
            quantityInput.value = option.dataset.qty;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  // --- Sticky Add to Cart (mobile) ---
  function initStickyAtc() {
    var bar = document.querySelector('.cro-sticky-atc');
    if (!bar) return;

    var mainButton = document.querySelector('#' + bar.dataset.observeButtonId);
    if (!mainButton) return;

    var stickyButton = bar.querySelector('button[data-cro-sticky-submit]');
    var mainForm = document.getElementById(bar.dataset.formId);
    if (stickyButton && mainForm) {
      stickyButton.addEventListener('click', function () {
        if (mainButton && !mainButton.disabled) {
          mainButton.click();
        }
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  function run() {
    initCountdowns();
    initPackPricing();
    initStickyAtc();
  }
})();
